function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M59.33,13.33c-0.77-0.88-2.02-1.16-3.09-0.69l-5.3,2.3C46.24,7.33,37.9,2.58,28.8,2.58 c-12.77,0-23.83,9.5-25.74,22.11c-0.22,1.47,0.79,2.84,2.26,3.06c0.14,0.02,0.27,0.03,0.41,0.03c1.31,0,2.45-0.96,2.66-2.29 C9.89,15.5,18.67,7.96,28.8,7.96c6.95,0,13.34,3.5,17.14,9.14l-4.69,2.03c-1.07,0.47-1.72,1.57-1.61,2.73s0.97,2.12,2.11,2.36 l9.82,2.1c0.19,0.04,0.38,0.06,0.56,0.06c0.93,0,1.81-0.48,2.31-1.3l5.17-8.61C60.22,15.48,60.1,14.21,59.33,13.33z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0.67,46.67c0.77,0.88,2.02,1.16,3.09,0.69l5.3-2.3c4.7,7.6,13.04,12.35,22.15,12.35 c12.77,0,23.83-9.5,25.74-22.11c0.22-1.47-0.79-2.84-2.26-3.06c-0.14-0.02-0.27-0.03-0.41-0.03c-1.31,0-2.45,0.96-2.66,2.29 c-1.51,10-10.29,17.53-20.42,17.53c-6.95,0-13.34-3.5-17.14-9.14l4.69-2.03c1.07-0.47,1.72-1.57,1.61-2.73s-0.97-2.12-2.11-2.36 l-9.82-2.1c-0.19-0.04-0.38-0.06-0.56-0.06c-0.93,0-1.81,0.48-2.31,1.3l-5.17,8.61C-0.22,44.52-0.1,45.79,0.67,46.67z"
}));

var SvgRefreshIcon = function SvgRefreshIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRefreshIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh-icon.4b29d55f.svg";
export { ForwardRef as ReactComponent };